import type { ReactNode } from 'react'

interface AuthLayoutProps {
  children: ReactNode
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <main className="flex min-h-dvh flex-col px-4 py-4 sm:px-6 sm:py-8 lg:px-8 lg:py-10">
      <div className="flex grow items-start justify-center sm:items-center">{children}</div>
    </main>
  )
}
